import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "flex flex-row w-full justify-center" }
const _hoisted_3 = { class: "w-9/12" }
const _hoisted_4 = {
  key: 1,
  class: "flex w-full justify-center pt-3"
}
const _hoisted_5 = { class: "w-9/12 flex flex-col" }
const _hoisted_6 = {
  key: 2,
  class: "w-full py-3 flex flex-row justify-center"
}
const _hoisted_7 = {
  key: 3,
  class: "w-full py-5 flex flex-row justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-primary text-center" }, "No results found. try creating a candidate from the pool", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_CardJobCandidate = _resolveComponent("CardJobCandidate")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SearchInput, {
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          placeholder: "Search candidate",
          onOnSubmit: _ctx.getCandidates
        }, null, 8, ["modelValue", "onOnSubmit"])
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CardJobCandidate, {
              candidates: _ctx.candidates?.candidates,
              onGetCandidates: _ctx.getCandidatesOutside,
              onReloadCandidates: _ctx.getCandidates
            }, null, 8, ["candidates", "onGetCandidates", "onReloadCandidates"])
          ])
        ])),
    (_ctx.candidates?.candidates?.length > 0 && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_pagination, {
            modelValue: _ctx.page,
            pages: _ctx.candidates?.meta?.pagination?.total_pages,
            "range-size": 1,
            "active-color": "#4D00C5",
            "onUpdate:modelValue": _ctx.updateHandler
          }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.candidates?.candidates?.length <= 0 && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}